import { useState, useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import useRefreshToken from './../hooks/useRefreshToken'
import useAuth from './../hooks/useAuth'
import Loading from './Loading'
import jwtDecode from 'jwt-decode'
import { Helmet } from 'react-helmet-async';

const PersistLogin = () => {
  const [loading, setLoading] = useState(true)
  const { setAuth } = useAuth()
  const refresh = useRefreshToken()
  const navigate = useNavigate()

  useEffect(() => {
    let isMounted = true

    const goToLogin = () => {
      localStorage.removeItem('user')
      setAuth({})
      navigate('/login', { replace: true })
    }

    const initAuth = async () => {
      let storedUser = null

      try {
        const raw = localStorage.getItem('user')
        storedUser = raw ? JSON.parse(raw) : null
      } catch {
        if (isMounted) goToLogin()
        return
      }

      if (!storedUser?.a || !storedUser?.r) {
        if (isMounted) goToLogin()
        return
      }

      let readToken
      try {
        readToken = jwtDecode(storedUser.a)
      } catch {
        // توکن خراب/نامعتبر → جلوگیری از صفحه سفید و هدایت به لاگین
        if (isMounted) goToLogin()
        return
      }

      const role = Array.isArray(readToken.role) ? readToken.role : [readToken.role]
      const user = readToken.preferred_username
      const userId = readToken.sub
      const userMediaName = readToken.media_name

      if (isMounted) {
        setAuth({
          user,
          userId,
          userMediaName,
          role,
          accessToken: storedUser.a,
          refreshToken: storedUser.r,
        })
      }

      const isExpired = !readToken.exp || readToken.exp * 1000 < Date.now()

      if (isExpired) {
        try {
          await refresh()
        } catch {
          if (isMounted) goToLogin()
          return
        }
      }

      if (isMounted) setLoading(false)
    }

    initAuth()

    return () => {
      isMounted = false
    }
  }, [])

  return <>
    <Helmet>
      <title>داشبورد سکانس</title>
    </Helmet>
    {loading ? <Loading /> : <Outlet />}
  </>
}
export default PersistLogin
